import { useNavigate } from "react-router-dom";
import useCTX from "../hooks/useCTX";
import { Edit3 } from "lucide-react";

/**
 * EditSyllabusButton Component
 * Custom button to edit syllabus without MUI dependencies.
 * Uses lucide-react for icons and Tailwind for styling.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.syllabus - Syllabus ID
 * @param {string} props.unit - Unit ID
 * @param {string} props.lesson - Lesson ID
 *
 * @author Forge
 * @date 2026-04-10
 * @version 2.0.0
 */
export default function EditSyllabusButton({ syllabus, unit, lesson }) {
  const { user } = useCTX();
  const navigate = useNavigate();

  const canEdit = user?.roles?.includes("Head Teacher") || user?.roles?.includes("Manager");

  if (!canEdit) return null;

  return (
    <button
      onClick={() =>
        navigate(
          `/teaching/syllabus/${syllabus}${unit ? `/unit/${unit}` : ""}${
            lesson ? `/lesson/${lesson}` : ""
          }`
        )
      }
      className="p-1.5 rounded-lg bg-white hover:bg-slate-50 border border-slate-200 text-slate-400 hover:text-sky-600 hover:border-sky-300 transition-all cursor-pointer"
      title="Edit syllabus"
    >
      <Edit3 size={14} strokeWidth={2.5} />
    </button>
  );
}